import axios from 'axios'
import setupAxios from '@utilities/setupAxios'
setupAxios()

export function getPropertyDetailApi(propertyId: string) {
  return axios.get('/api/v1/properties/' + propertyId + '/')
}

export function getPropertiesApi() {
  return axios.get('/api/v1/properties/')
}
